<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Formulario EI 113</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                        <v-spacer></v-spacer>
                        <div>
                            <!-- <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
                        </div>
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4" class="py-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                Área: {{ nomarea }}
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                Fecha: {{ fecha }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="10" align-self="stretch">
                                <v-radio-group v-model="tipo" row dense>
                                    <v-radio label="Informe" value="IN"></v-radio>
                                    <v-radio label="Aviso de Cambio" value="AV"></v-radio>
                                    <v-radio class="label" label="Minuta de Reunión" value="MI"></v-radio>
                                    <v-radio label="Sugerencia de Mejora" value="SU"></v-radio>
                                    <v-radio label="Memorandum" value="ME"></v-radio>
                                    <v-radio label="Otros" value="OT"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4" md="4">
                                <v-text-field dense v-if="tipo == 'OT'" label="Otro:" v-model="otro"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="4" md="4">
                                De: {{ de }}
                                <!-- <v-text-field required :rules="requiredRules" label="De" dense v-model="de"></v-text-field> -->
                            </v-col>
                            <v-col cols="6" sm="4" md="4">
                                Para: {{ para }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="6">
                                Referencia: {{ ref }}
                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                                N° de OT: {{ numot }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card class="py-0">
                    <v-card-text class="py-0">
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <h6>Descripción:</h6>
                                <div class="multi-line">
                                    {{ descr }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="this.tipo == 'IN'" class="py-0">
                    <v-card-text>
                        <v-data-table dense :headers="headersO" :items="observaciones" locale="es-ar"
                            class="elevation-1" hide-default-footer :items-per-page="50" :footer-props="{
                                itemsPerPageText: 'Items por página',
                            }">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Observaciones</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                        </v-data-table>

                    </v-card-text>
                </v-card>

                <v-card v-if="this.tipo == 'SU'" class="py-0">
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="acciones" locale="es-ar" class="elevation-1"
                            :items-per-page="50" hide-default-footer :footer-props="{
                                itemsPerPageText: 'Items por página',
                            }" :item-class="row_classes">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Acciones</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>

                                </v-toolbar>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-card v-if="this.tipo == 'SU'" class="py-0">
                    <v-card-text>
                        <v-data-table dense :headers="headersS" :items="seguimientos" locale="es-ar" class="elevation-1"
                            :items-per-page="50" hide-default-footer :footer-props="{
                                itemsPerPageText: 'Items por página',
                            }" :item-class="row_classes">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Seguimiento</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>

                                </v-toolbar>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>

                            <v-col cols="6" sm="3" md="3">
                                Estado: {{ estado }}

                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-if="fileInfos.length > 0" class="mx-auto">
                    <v-list>
                        <v-subheader>Lista de archivos</v-subheader>
                        <v-list-item-group color="primary">
                            <v-list-item v-for="(file, index) in fileInfos" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title class="mb-3">

                                        <a target="_blank" :href="'https://api.icssa.com.ar/informes/' + file.descripcion
                                            ">{{ file.titulo }}</a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<style scoped>
.multi-line {
    white-space: pre-line;
}

.orange {
    background-color: orange;
}

.red {
    background-color: red;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        codgral: "",
        valid: false,
        validsubir: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        id: "",
        de: "",
        listadode: [],
        para: "",
        ref: "",
        tipo: "",
        otro: "",
        numot: "",
        descr: "",
        estado: "",
        fotos: [],
        nomarea: "",
        direcciones: [],
        direccion: "",
        correos: "",
        destinatarios: [],
        mail: [{ address: "" }],
        fecha: moment().format("DD/MM/YYYY"),
        selectedFiles: "",
        progressInfos: [],
        archivo: [],
        rulesarchivos: [
            (value) =>
                !value || value.size < 3000000 || "Las fotos deben pesar 3MB o menos",
        ],
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        selectedFiles: undefined,
        progressInfos: [],
        message: "",
        titulo: "",
        fileInfos: [],
        headers: [
            { text: "Item", value: "item", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Responsable", value: "resp", sortable: false },
            { text: "Participantes", value: "participante", sortable: false },
            { text: "Fecha a cumplir", value: "fecha", sortable: false },
            { text: "Cumplido", value: "estado", sortable: false },
        ],
        headersS: [
            { text: "Item", value: "item", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Cumplido", value: "cumplido", sortable: false },
            { text: "Acta", value: "acta", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
        ],
        headersO: [
            { text: "Item", value: "item", sortable: false },
            { text: "Descripción", value: "observ", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
        ],
        cumplido: [
            { texto: 'NO', abbr: 'N' },
            { texto: 'SI', abbr: 'S' }
        ],

        acciones: [],
        accion: [],
        seguimientos: [],
        seguim: [],
        observaciones: [],
    }),
    watch: {


    },
    // props: ["visible", "area", "codarea"],
    computed: {
        show: {
            get() {
                //this.mostrar = true;
                // this.elaboro = this.$store.state.nombre.toString().trim();
                //this.cargarSM();
                //return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        row_classes(item) {
            if (item.estado == "N" && moment(item.fecha, "DD/MM/YYYY") < moment()) {
                return "red";
            }
            if (item.estado == "N" && moment(item.fecha, "DD/MM/YYYY") > moment()) {
                return "green";
            }
        },
        vaciarModels() {

            this.mail = [];
            this.tipo = "";
            this.descr = "";
            this.ref = "";
            this.de = "";
            this.para = "";
            this.fileInfos = [];
            this.fecha = "";
            this.accion = [];
            this.acciones = [];
            this.seguim = [];
            this.seguimientos = [];
            //this.codigoarea();
        },



        cargarSM() {
            const area = this.area;
            const codarea = this.codarea;
            if (this.area == "AB") { this.nomarea = "Abastecimiento" };
            if (this.area == "AD") { this.nomarea = "Administración y Finanzas" };
            if (this.area == "AU") { this.nomarea = "Auditoría" };
            if (this.area == "BA") { this.nomarea = "Buenos Aires" };
            if (this.area == "CO") { this.nomarea = "Comercial" };
            if (this.area == "CC") { this.nomarea = "Comité de SGI" };
            if (this.area == "CG") { this.nomarea = "Control de Gestión" };
            if (this.area == "DE") { this.nomarea = "Depósito" };
            if (this.area == "DI") { this.nomarea = "Dirección" };
            if (this.area == "FA") { this.nomarea = "Fabricación" };
            if (this.area == "CA") { this.nomarea = "Gerencia del SGI" };
            if (this.area == "HS") { this.nomarea = "Higiene y Seguridad" };
            if (this.area == "IN") { this.nomarea = "Ingeniería de Obra" };
            if (this.area == "IP") { this.nomarea = "Ingeniería de Producto" };
            if (this.area == "IC") { this.nomarea = "Inspección y Ensayos" };
            if (this.area == "JO") { this.nomarea = "Jefe de Obra" };
            if (this.area == "ML") { this.nomarea = "Medicina Laboral" };
            if (this.area == "MA") { this.nomarea = "Medio Ambiente" };
            if (this.area == "OS") { this.nomarea = "Obras y Servicios" };
            if (this.area == "SG") { this.nomarea = "Servicios Generales" };
            if (this.area == "TD") { this.nomarea = "Técnica y Desarrollo" };
            let self = this;
            axios
                .get("/App/CargarEI113SM?", {
                    params: {
                        area: area,
                        codarea: codarea,
                    },
                })
                .then((response) => {

                    self.id = response.data.id;
                    self.codgral = response.data.codgral;
                    self.tipo = response.data.tipo;
                    self.otro = response.data.otro;
                    self.de = response.data.de;
                    self.para = response.data.para;
                    self.ref = response.data.ref;
                    self.fecha = response.data.fecha;
                    self.numot = response.data.numot;
                    self.descr = response.data.descr;
                    if (response.data.estado == "P") {
                        self.estado = "Pendiente"
                    };
                    if (response.data.estado == "C" || response.data.estado == "T") {
                        self.estado = "Cerrado"
                    };
                    self.fileInfos = response.data.informes;
                    self.observaciones = response.data.observaciones;
                    self.acciones = response.data.acciones;
                    self.seguimientos = response.data.seguimiento;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },


        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },

    beforeMount() {
        this.area = this.$route.query.area;
        this.codarea = this.$route.query.codarea;
        this.cargarSM();

        return this.visible;
    },
};
</script>
